import * as amplitude from "@amplitude/unified";
import { AMPLITUDE_API_KEY } from "./config";

let initialized = false;

export const EVENTS = {
  SMS_SENT: "SMS Sent",
  VOICE_CAMPAIGN_STARTED: "Voice Campaign Started",
  SENDER_ID_REQUESTED: "Sender ID Requested",
};

export const initAmplitude = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  amplitude.initAll(AMPLITUDE_API_KEY, {
    analytics: {
      fetchRemoteConfig: true,
      autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        elementInteractions: true,
        formInteractions: true,
        fileDownloads: true,
      },
    },
    sessionReplay: { sampleRate: 1 },
  });
};

// Ties events to the SSO user. Email and phone number are left out on purpose.
export const identifyUser = (user = {}, account = {}) => {
  if (!user.user_id) return;
  amplitude.setUserId(String(user.user_id).trim());
  const identify = new amplitude.Identify()
    .set("role", user.role || "")
    .set("account_id", account.id || user.account_id || "")
    .set("account_name", account.name || "")
    .set("country", user.signup_country || user.country || "");
  amplitude.identify(identify);
};

export const resetUser = () => {
  amplitude.reset();
};

export const trackEvent = (name, properties) => {
  amplitude.track(name, properties);
};

export default amplitude;
